/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentFormComment } from './IncidentFormComment';
import {
    IncidentFormCommentFromJSON,
    IncidentFormCommentFromJSONTyped,
    IncidentFormCommentToJSON,
} from './IncidentFormComment';

/**
 * 
 * @export
 * @interface CreateIncidentFormComment200Response
 */
export interface CreateIncidentFormComment200Response {
    /**
     * 
     * @type {IncidentFormComment}
     * @memberof CreateIncidentFormComment200Response
     */
    data?: IncidentFormComment;
}

/**
 * Check if a given object implements the CreateIncidentFormComment200Response interface.
 */
export function instanceOfCreateIncidentFormComment200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateIncidentFormComment200ResponseFromJSON(json: any): CreateIncidentFormComment200Response {
    return CreateIncidentFormComment200ResponseFromJSONTyped(json, false);
}

export function CreateIncidentFormComment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIncidentFormComment200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : IncidentFormCommentFromJSON(json['data']),
    };
}

export function CreateIncidentFormComment200ResponseToJSON(value?: CreateIncidentFormComment200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': IncidentFormCommentToJSON(value.data),
    };
}

